import { useCallback, useState } from 'react';
import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

const classUtils = MojitoCore.Base.classUtils;
const { FlexPane, Image, Text, SportsFilter } = MojitoPresentation.Components;
const EMPTY_SPORT_IDS = [];

export default function SportsFilterContainer(props) {
    const {
        mojitoTools: { config, stringResolver },
        sportIds: sportIdsFromProps = EMPTY_SPORT_IDS,
        children,
        class: className,
    } = props;
    const [appliedSportIds, setAppliedSportIds] = useState();
    const [selectedSportId, setSelectedSportId] = useState();

    const applySports = useCallback(ids => {
        setAppliedSportIds(ids);
        // A sport that is no longer available stays deselected even if it comes back later.
        setSelectedSportId(current => (ids.includes(current) ? current : undefined));
    }, []);

    const filterSportIds = appliedSportIds ?? sportIdsFromProps;
    const content = children(selectedSportId, applySports);

    if (filterSportIds.length === 0) {
        return content;
    }

    const sectionTitle = stringResolver.resolveString(config.sectionTitleKey);
    const showSectionHeader = sectionTitle && config.sectionIcon;
    const showSportsFilter = filterSportIds.length >= config.minSportsCount;

    return (
        <FlexPane
            config={config.container}
            class={classUtils.classNames('ta-SportsFilterContainer', className)}
        >
            {(showSectionHeader || showSportsFilter) && (
                <FlexPane config={config.filterRow} class="ta-filterRow">
                    {showSectionHeader && (
                        <FlexPane
                            config={config.sectionHeader}
                            class="ta-SportsFilterContainer-sectionHeader"
                        >
                            <Image
                                src={config.sectionIcon}
                                config={config.sectionIconImage}
                                class="ta-SportsFilterContainer-sectionIcon"
                            />
                            <Text
                                config={config.sectionTitle}
                                class="ta-SportsFilterContainer-sectionTitle"
                            >
                                {sectionTitle}
                            </Text>
                        </FlexPane>
                    )}
                    {showSportsFilter && (
                        <SportsFilter
                            config={config.sportsFilter}
                            sportIds={filterSportIds}
                            selectedSportId={selectedSportId}
                            onSportChange={setSelectedSportId}
                        />
                    )}
                </FlexPane>
            )}
            <FlexPane config={config.contentContainer} class="ta-SportsFilterContainer-content">
                {content}
            </FlexPane>
        </FlexPane>
    );
}
